import { render, staticRenderFns } from "./shouyinTable.vue?vue&type=template&id=af2ba034&"
import script from "./shouyinTable.vue?vue&type=script&lang=js&"
export * from "./shouyinTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports